import {
  ShoppingCart,
  Package,
  Users,
  Printer,
  Settings,
  Tractor,
  Key,
  Shield,
  User,
  TrendingUp,
  FileText,
  BarChart3,
  LayoutDashboard,
  Truck,
  Box,
  Wrench,
  PackageOpen,
} from "lucide-react";
import React from "react";

export type IconComponent = React.ComponentType<{
  size?: number;
  className?: string;
}>;

export type NavItem = {
  path: string;
  label: string;
  icon?: IconComponent;
  end?: boolean;
  adminOnly?: boolean;
  permission?: string;
  // Sub-items for header tabs
  subItems?: {
    path: string;
    label: string;
    icon?: IconComponent;
    end?: boolean;
    adminOnly?: boolean;
    permission?: string;
  }[];
};

export const navigationConfig: NavItem[] = [
  {
    path: "/dashboard",
    label: "Dashboard",
    icon: BarChart3,
  },
  {
    path: "/comandas",
    label: "Ventas",
    icon: ShoppingCart,
    permission: "WorkOrders.View",
    subItems: [
      {
        path: "/comandas",
        label: "Ventas",
        icon: ShoppingCart,
        end: true,
        permission: "WorkOrders.View",
      },
      {
        path: "/comandas/estadisticas",
        label: "Estadísticas",
        icon: BarChart3,
        permission: "WorkOrders.View",
      },
      {
        path: "/comandas/ajustes",
        label: "Ajustes",
        icon: Settings,
        permission: "Settings.View",
      },
    ],
  },
  {
    path: "/produccion",
    label: "Producción",
    icon: TrendingUp,
    permission: "Production.View",
  },
  {
    path: "/productos",
    label: "Productos",
    icon: Package,
    permission: "Items.View",
    subItems: [
      {
        path: "/productos",
        label: "Lista de Productos",
        icon: Package,
        end: true,
        permission: "Items.View",
      },
      {
        path: "/productos/envases",
        label: "Envases",
        icon: Box,
        permission: "Items.View",
      },
    ],
  },
  {
    path: "/usuarios",
    label: "Usuarios",
    icon: Users,
    permission: "Users.View",
    subItems: [
      {
        path: "/usuarios",
        label: "Gestión de Usuarios",
        icon: User,
        end: true,
        permission: "Users.View",
      },
      {
        path: "/usuarios/roles",
        label: "Roles y Permisos",
        icon: Shield,
        permission: "Users.ManageRoles",
      },
    ],
  },
  {
    path: "/impresoras",
    label: "Impresoras",
    icon: Printer,
    permission: "Printing.View",
  },
  {
    path: "/agricultores",
    label: "Agricultores",
    icon: Tractor,
    permission: "Farmers.View",
  },
  {
    path: "/partidas",
    label: "Partidas",
    icon: PackageOpen,
    permission: "Intakes.View",
  },
  {
    path: "/clientes",
    label: "Clientes",
    icon: Users,
    permission: "WorkOrders.View",
  },
  {
    path: "/logistica",
    label: "Logística",
    icon: Truck,
    permission: "Logistics.ViewRoutes",
    subItems: [
      {
        path: "/logistica/rutas",
        label: "Rutas",
        permission: "Logistics.ViewRoutes",
      },
      {
        path: "/logistica/vehiculos",
        label: "Vehículos",
        permission: "Logistics.ViewVehicles",
      },
      {
        path: "/logistica/conductores",
        label: "Conductores",
        permission: "Logistics.ViewDrivers",
      },
      {
        path: "/logistica/planes-carga",
        label: "Planes de Carga",
        permission: "Logistics.ViewRoutes",
      },
      {
        path: "/logistica/tipos-palet",
        label: "Tipos de Palet",
        permission: "Logistics.ViewRoutes",
      },
    ],
  },
  {
    path: "/mantenimiento",
    label: "Mantenimiento",
    icon: Wrench,
    permission: "Maintenance.Access",
    subItems: [
      {
        path: "/mantenimiento/tareas",
        label: "Tareas",
        permission: "Maintenance.Access",
      },
      {
        path: "/mantenimiento/equipos",
        label: "Equipos",
        permission: "Maintenance.Access",
      },
      {
        path: "/mantenimiento/areas",
        label: "Áreas",
        permission: "Maintenance.Access",
      },
      {
        path: "/mantenimiento/calendario",
        label: "Calendario",
        permission: "Maintenance.Access",
      },
    ],
  },
  {
    path: "/auditoria",
    label: "Auditoría",
    icon: FileText,
    permission: "Auditing.View",
  },
  {
    path: "/configuracion",
    label: "Configuración",
    icon: Settings,
    permission: "Settings.View",
    subItems: [
      { path: "/configuracion", label: "General", end: true },
      {
        path: "/configuracion/clientes-oauth",
        label: "Clientes OAuth",
        icon: Key,
        adminOnly: true,
        permission: "Users.ManageRoles",
      },
    ],
  },
];
